/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Resourcespermissionstitle2Inputs */

const en_settings_resourcespermissionstitle2 = /** @type {(inputs: Settings_Resourcespermissionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Roles - Permission tables`)
};

/**
* | output |
* | --- |
* | "User Roles - Permission tables" |
*
* @param {Settings_Resourcespermissionstitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_resourcespermissionstitle2 = /** @type {((inputs?: Settings_Resourcespermissionstitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Resourcespermissionstitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_resourcespermissionstitle2(inputs)
});
export { settings_resourcespermissionstitle2 as "settings_resourcesPermissionsTitle" }